import Step from '../components/Step'

const steps = [
  {
    number: 1,
    title: "Descarga la aplicación",
    description: "Disponible ahora en esta página y proximamente en Google Play Store. Instalación rápida y segura."
  },
  {
    number: 2,
    title: "Crea tu perfil",
    description: "Regístrate en segundos con tu cuenta de Googleo o el e-mail de tu preferencia, agrega tu información básica y listo."
  },
  {
    number: 3,
    title: "Elige tu experiencia",
    description: "Disfruta de nuestras apps gratuitas o adquiere la licencia premium de Ascensos App Vortex para acceso completo a todas las herramientas avanzadas."
  },
  {
    number: 4,
    title: "Disfruta el proceso",
    description: "Haz que tu viaje a ese Ascenso sea diferente a todos los demas, disciplina, constancia y Vortex seran la llave para tus metas."
  }
]

export default function HowItWorks() {
  return (
    <section id="howitworks" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>¿Cómo empezar?</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            En solo 4 pasos y estarás listo para disfrutar de nuestras aplicaciones innovadoras.
          </p>
        </div>

        <div className="grid grid-4">
          {steps.map((step, index) => (
            <Step
              key={index}
              number={step.number}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>

        <div style={{
          marginTop: 'var(--spacing-3xl)',
          padding: 'var(--spacing-2xl)',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            Nuestras Aplicaciones
          </h3>
          <div style={{ textAlign: 'left', marginBottom: 'var(--spacing-lg)' }}>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Scout Conecta:</strong> Aplicación definitiva para el movimiento scout mexicano, diseñada para conectar, educar y gestionar a scouts, scouters y administradores de manera integral con interfaz intuitiva y herramientas avanzadas.
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Ascensos App Vortex (Premium):</strong> Sistema integral de educación para la Marina de México con IA avanzada. Incluye más de 1200 preguntas, audios de Conocimientos Marineros, Legislación Naval e Historia Naval, simulador de exámenes, y 4 herramientas de IA: VORTEX AI (asistente digital), VORTEX QUIZZ (generador de cuestionarios), VORTEX AUDIO (conversión texto-a-voz) y VORTEX DOCS (extracción y resumen de documentos).
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Vortex Texto - Audio:</strong> Transforma cualquier texto en audio de alta calidad con tecnología avanzada de síntesis de voz. Ideal para estudiantes y profesionales que prefieren escuchar contenido.
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Vortex Audio Texto IA:</strong> Convierte grabaciones de voz y archivos de audio en texto con precisión usando modelos avanzados de IA Whisper. Perfecto para transcribir reuniones, clases y notas de voz.
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Flashcard Vortex:</strong> Revoluciona el estudio combinando tarjetas tradicionales con IA de vanguardia. Genera tarjetas automáticamente, organiza por asignaturas y utiliza algoritmos de repetición espaciada para aprendizaje efectivo.
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Ascensos App Lite:</strong> Versión especializada para preparación de exámenes de ascenso en la Marina de México. Incluye quizzes temáticos, simulador de exámenes y contenido educativo estructurado.
            </p>
            <p style={{ marginBottom: 'var(--spacing-md)', fontSize: '1rem', textAlign: 'justify' }}>
              <strong>Cuentos que enseñan:</strong> Transforma temas escolares aburridos en aventuras emocionantes usando IA. Genera cuentos personalizados adaptados al grado escolar y gustos del niño, fomentando el hábito de lectura.
            </p>
          </div>
          <p style={{ marginBottom: 'var(--spacing-lg)', fontSize: '1.1rem', textAlign: 'center', fontWeight: 'bold' }}>
            ¡EXPLORA NUESTRAS APLICACIONES GRATUITAS Y DESCUBRE CÓMO LA TECNOLOGÍA PUEDE TRANSFORMAR TU APRENDIZAJE!
          </p>

          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            ¿Listo para comenzar?
          </h3>
          <p style={{ marginBottom: 'var(--spacing-xl)' }}>
            Descarga nuestras aplicaciones gratuitas hoy mismo o contacta con nosotros para más información sobre Ascensos App Vortex premium
          </p>
          <a href="#availability" className="btn btn-secondary">
            Explorar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
} 